// Hard coded, default gift card denominations in cents. $25 to $100.
export const DEFAULT_GIFT_CARD_DEMONINATIONS = [25_00, 50_00, 75_00, 100_00]
